<script setup lang="ts"></script>

<template>
  <div absolute top="md:0 -20" left=" md:0 -90" opacity-70 blur-275px dark:hidden w="md:272px 457px" h="md:272px 427px">
    <div w-full h-full bg-primary-400 />
  </div>
</template>
